import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

const requestHeaderTableData = {
  columns: [
    { Header: "S/N", accessor: "num", align: "left", width: "5%" },
    { Header: "Key", accessor: "key", align: "left", width: "25%" },
    { Header: "Value", accessor: "value", align: "left" },
  ],
  rows: [
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          1
        </MDTypography>
      ),
      key: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          x-client-initiated-request-timestamp
        </MDTypography>
      ),
      value: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
        </MDTypography>
      ),
    },
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          2
        </MDTypography>
      ),
      key: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          Authorization
        </MDTypography>
      ),
      value: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          {"Bearer <access_token>"}
        </MDTypography>
      ),
    },
  ],
};

const bodyColumnHeaders = [
  { Header: "S/N", accessor: "num", align: "left", width: "5%" },
  { Header: "Field", accessor: "field", align: "left", width: "15%" },
  { Header: "", accessor: "datatype", align: "center", width: "10%" },
  { Header: "Description", accessor: "description", align: "left" },
];

let tradingApiData = [
  {
    staticData: true,
    mainHeading: "Introduction",
    mainGridId: "introduction",
    mainHeadingDesc:
      "The OMS API is designed to ensure that buy/sell/short-sell order management is as easy as possible. Please follow the guidelines of the API and in case of any questions, please contact relevant personnel within VCT Technologies LLC.",
    mainHeadingDesc2:
      "This document should be utilized by users/clients/customers while designing their solutions.",
  },
  {
    staticDataTwo: true,
    mainHeading: "Environment",
    mainGridId: "environment",
    generalDescWithLinkOne: {
      desc: "To access the sandbox, please use the provided URL.",
      link: "https://demo.vtraderweb.com:6002/",
    },
    textOne: "In the document, this URL will be termed as",
    textTwo: "<base_url>",
    textThree: "All APIs will respond to data in application/JSON format.",
  },
  // Authorization Data
  {
    mainHeading: "Authorizations",
    mainHeadingDesc:
      "This section provides a guide on generating Access Tokens that allow access to the protected API endpoints. If the access token is invalid or expired, an error message will pop up with a 401 status code for unauthorized access.",
    mainGridId: "authorizations",
  },
  {
    mainGridId: "request-access-token",
    subHeading: "Request Access Token",
    subHeadingDesc:
      "The Request Access Token endpoint can be used to request a new access token and a refresh token which is essential to keep the session alive.",
    endPointId: "request-access-token-request-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "POST",
    endPointDesc: "<base_url>/connect/token",
    requestHeaderId: "request-access-token-request-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              application/x-www-form-urlencoded
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "request-access-token-request-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              grant_type<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Grant types are a way to specify how a client wants to <br />
              interact. The default value is "password" for this request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              client_id<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The client ID that is assigned to a user for login.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              username<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The username that is assigned to a user for login.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              password<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The password provided to a user for login.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "request-access-token-success",
    respBody: "Response Body",
    respBodySuccessDesc:
      "	Access tokens expire after the time specified in the “Expires_in” property has elapsed. To get a new token without user interaction, use the Renew Access Token endpoint.",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              access_token
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Access Tokens are used to access authorized APIs.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              expires_in
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The access token expiry will be shown in seconds.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              token_type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of token requested.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              refresh_token
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Refresh tokens allow requesting new access tokens without user
              <br /> interaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              scope
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies which APIs were accessed.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "request-access-token-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              error
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies error name.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              error_description
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              A description of the type of error.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    respObjKey: "login_trading_api",
  },
  // Renew Access Token
  {
    mainGridId: "renew-access-token",
    subHeading: "Renew Access (Refresh) Token ",
    subHeadingDesc:
      "Since access tokens have finite lifetimes, Renew Tokens allow requesting new access tokens without user interaction.",
    endPointHeading: "Request Endpoint",
    endPointId: "renew-access-token-request-endpoint",
    endPointMethod: "POST",
    endPointDesc: "<base_url>/connect/token",
    requestHeaderId: "renew-access-token-request-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              application/x-www-form-urlencoded
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "renew-access-token-request-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              grant_type<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Grant Types are a way to specify how a client wants to interact.
              The default value is "password" for this request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              client_id<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The client ID that is assigned to a user for login.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              refresh_token<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Refresh Tokens are granted when requesting an access token API.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "renew-access-token-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              access_token
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Access Tokens are used to access authorized APIs.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              expires_in
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Access token expiry will be shown in seconds.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              token_type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of token requested.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              refresh_token
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Refresh tokens allow requesting new access tokens without user
              <br /> interaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              scope
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies which APIs were accessed.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "renew-access-token-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              error
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies the error name.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              error_description
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              A description of the type of error.
            </MDTypography>
          ),
        },
      ],
    },
  },
  // End Session
  {
    mainGridId: "end-session",
    subHeading: "End Session",
    subHeadingDesc:
      "This endpoint ends a user's session after which they cannot renew the access token via the Renew Access Token endpoint.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "POST",
    endPointId: "end-session-request-endpoint",
    endPointDesc: "<base_url>/connect/revocation",
    requestHeaderId: "end-session-token-request-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              application/x-www-form-urlencoded
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "end-session-token-request-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              token_type_hint<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of token passed in the Token field to end the session.
              The default value of this request is “refresh_token".
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              client_id<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The client ID that is assigned to a user for login.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              token<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Refresh token is granted when requesting an access token API.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "end-session-token-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request result will show an empty body with the successful HTTP status code.",
    respBodyErrorId: "end-session-token-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Error
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies error name.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              error_description
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              A description of the type of error.
            </MDTypography>
          ),
        },
      ],
    },
  },
  // Static Accounts Data
  {
    mainGridId: "static-data",
    mainHeading: "Static Data",
    mainHeadingDesc:
      "Static Data provides essential information for the logged-in users such as the configured Accounts, Sides, TIFs, and more. This information is used in other API endpoint requests.",
  },
  {
    mainGridId: "static-data-accounts",

    // mainGridId: "static-data-accounts-endpoint",
    subHeading: "Accounts",
    subHeadingDesc:
      "The trading accounts assigned to a user can be retrieved using this endpoint.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "static-data-accounts-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/staticData/Account ",
    requestHeaderId: "static-data-accounts-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-accounts-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              booth
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Account’s Booth ID.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-accounts-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_accounts",
  },
  // Sides Data
  {
    mainGridId: "static-data-sides",
    subHeading: "Sides",
    subHeadingDesc:
      "Using this endpoint, users can retrieve the order Sides allowed to them.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "static-data-sides-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/staticData/Side",
    requestHeaderId: "static-data-sides-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-sides-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-accounts-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_side",
  },
  // Time In Force Data
  {
    mainGridId: "static-data-time-in-force",
    subHeading: "Time In Force",
    subHeadingDesc:
      "Time In Force will show users the allowed time in force when placing an order. It specifies how long an order remains active. With no Time In Force specified, orders are interpreted as DAY orders.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "static-data-tif-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/staticData/TIF",
    requestHeaderId: "static-data-tif-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-tif-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-tif-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_tif",
  },
  // Order Type Data
  {
    mainGridId: "static-data-order-type",
    subHeading: "Order Type",
    subHeadingDesc:
      "The Order Types will show users the allowed order types, including Market, Limit, Stop, Stop Limit, etc. when creating orders.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "static-data-ot-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/staticData/OrdType",
    requestHeaderId: "static-data-ot-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-ot-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    // respBodySuccessDesc: "This endpoint ends a user's session after which you cannot renew the access token via refresh token.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-ot-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_order_type",
  },
  // Locate Time In Force Data
  {
    mainGridId: "static-data-locate-time-in-force",
    subHeading: "Locate Time In Force",
    subHeadingDesc:
      "The Locate Time In Force will show users the allowed time in force when acquiring the locate. It specifies how long the Locate remains in effect. With no Locate Time In Force specified, the default is set as DAY.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "static-data-ltif-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/staticData/LocateTIF",
    requestHeaderId: "static-data-ltif-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-ltif-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    // respBodySuccessDesc: "This endpoint ends a user's session after which you cannot renew the access token via refresh token.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-ltif-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_locate_tif",
  },
  // Destination Data
  {
    mainGridId: "static-data-destination",
    subHeading: "Destination",
    subHeadingDesc:
      "The Destination endpoint will give you the allowed destinations for placing an order.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/staticData/Destination",
    requestHeaderId: "static-data-ltif-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-dest-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    // respBodySuccessDesc: "This endpoint ends a user's session after which you cannot renew the access token via refresh token.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-dest-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_destination",
  },
  // Add Order Data
  {
    mainGridId: "orders",
    mainHeading: "Orders",
    mainHeadingDesc:
      "The Orders APIs allow users to create, modify, and cancel orders. The input parameters for each API are defined below the respective endpoint. The allowed values for these input parameters can be fetched using the Static Data endpoint.",
    mainHeadingDesc2:
      "Updates related to the order such as executions and positions can be fetched using the Orders Subscription endpoints.",
  },
  {
    mainGridId: "orders-add-order",
    subHeading: "Add Order",
    subHeadingDesc:
      "Using this API, an order can be sent to the market or destination. The order parameters can be set according to the specifications mentioned in the request body.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "POST",
    endPointDesc: "<base_url>/ext/ord/api/orders",
    endPointId: "orders-add-order-endpoint",
    requestHeaderId: "orders-add-order-req-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              text/plain
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Authorization
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"Bearer <access_token>"}
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "orders-add-order-req-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This includes the side of the order. Valid values:
              <ul className="bullets">
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
              </ul>
              where, 1=Buy, 2=Sell, and 5=Sell short.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order. The Quantity values will be displayed up
              to 6 decimal places only. Since this is a decimal type, any
              quantity entered with non-zero fractional part will be considered
              a fractional order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This represents the ticker symbol.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of order to be created. Valid values:
              <ul className="bullets">
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"4"</li>
              </ul>
              where, 1=Market, 2=Limit, 3=Stop, 4=Stop limit.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price per share. This field is valid only with Limit & Stop
              Limit order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              stopPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specified the stop price for the Order. The Stop Price field is
              valid only with Stop & Stop Limit order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account mnemonic as agreed between the broker and institution
              OR the account on behalf of which the order is to be placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              timeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies how long an order remains in effect. Valid values:
              <ul className="bullets">
                <li>"0"</li>
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"5"</li>
                <li>"6"</li>
              </ul>
              where, 0=Day, 1=DTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ID used to represent this transaction for compliance purposes.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Auto-generated IDs for locates acquired outside of API.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              contactName
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Name of the contact from where locates have been acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRequired
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              If true, an automated locate will be acquired from the Server.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The rate at which the automated locate will be acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              destination
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The execution venue where the orders will be routed. When this
              field is not provided, the system will consider the default
              Destination value, which is configured at server.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "request-access-token-success",
    respBody: "Response Body",
    respBodySuccessDesc:
      "A successful request shows an “Order Successfully Created” message with a successful HTTP status code. ",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyAcceptedCode: "Status Code: 202 (Accepted)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              replyType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies the type of replies. Each value is as follows:
              <ul className="bullets">
                <li>SERVER_REPLY_NONE,</li>
                <li>SERVER_REPLY_WARNING, // OK|Cancel</li>
                <li>SERVER_REPLY_QUESTION, // Yes|No</li>
                <li>SERVER_REPLY_ERROR, // OK</li>
                <li>SERVER_REPLY_SUCCESS</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              operation
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies the type of operations. Each value is as follows:
              <ul className="bullets">
                <li>OPERATION_NONE = 0,</li>
                <li>OPERATION_ETB_VALIDATION,</li>
                <li>OPERATION_RESTRICTED_SYMBOL_VALIDATION,</li>
                <li>SOPERATION_LIMIT_VALIDATION,</li>
                <li>OPERATION_LOCATE_QUOTE,</li>
                <li>OPERATION_LOCATE</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              message
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This field will display the message as per the response.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              extraParamsAvailable
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This field shows whether any extra parameters are available.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              extraParams
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Extra parameters are specific to that error message.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "request-access-token-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code. If the field’s value is invalid, it shows validation error messages, below the specified body.",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows the errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of <br />
              errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "orders_orders" //Commenting this b/c we don't have proper response in JSON format
  },
  // Update Order Data
  {
    mainGridId: "orders-update-order",
    subHeading: "Update Order",
    subHeadingDesc:
      "The Update Order API allows the user to modify a previously placed order. ",
    endPointHeading: "Request Endpoint",
    endPointMethod: "PUT",
    endPointId: "orders-update-order-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/orders",
    requestHeaderId: "orders-update-order-req-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              application/json
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Authorization
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"Bearer <access_token>"}
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "orders-update-order-req-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order. The Quantity values will be displayed up
              to 6 decimal places only.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price per share. This field is valid only with Limit & Stop
              Limit order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The order ID of the order which is to be updated.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of order to be updated. Valid values:
              <ul className="bullets">
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"4"</li>
              </ul>
              where, 1=Market, 2=Limit, 3=Stop, 4=Stop limit.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ID used to represent this transaction for compliance purposes.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "orders-update-order-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows an “Order Successfully Updated” message with a successful HTTP status code.",
    respBodyErrorId: "orders-cancel-order-bad",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code. If the field’s value is invalid, it shows validation error messages.",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows the errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "orders_cancel"  //Commenting this b/c we don't have proper response in JSON format
  },

  // Cancel Order Data
  {
    mainGridId: "orders-cancel-order",
    subHeading: "Cancel Order",
    subHeadingDesc:
      "	The Cancel Order API cancels the order that was previously placed.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "PATCH",
    endPointDesc: "<base_url>/ext/ord/api/orders",
    requestParamsId: "orders-cancel-order-req-params",
    requestParams: "Request Params",
    requestParamsTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        {
          Header: "Param Name",
          accessor: "paramname",
          align: "left",
          width: "15%",
        },
        { Header: "", accessor: "datatype", align: "center", width: "10%" },
        { Header: "Description", accessor: "description", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          paramname: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The order ID of the order which is to be updated, serving as a
              distinctive identitifer for reference and tracking.
            </MDTypography>
          ),
        },
      ],
    },
    requestHeaderId: "orders-cancel-order-req-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "orders-cancel-order-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows an “Order canceled successfully ” message with a successful HTTP status code.",
    respBodyErrorId: "orders-cancel-order-bad",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows the errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "orders_cancel"  //Commenting this b/c we don't have proper response in JSON format
  },
  // Option Order Data
  {
    mainGridId: "option-orders",
    mainHeading: "Option Orders",
    mainHeadingDesc:
      "The Options Orders APIs allow users to create, modify, and cancel options orders. The input parameters for each API are defined below the respective endpoints. The allowed values for these input parameters can be fetched using the Static Data endpoint. For example, the Order Types API can be used to fetch the allowed order types.",
    mainHeadingDesc2:
      "	Updates related to the options orders such as executions and positions can be fetched using the Options Subscription endpoints.",
  },
  {
    mainGridId: "add-option-order",
    subHeading: "Add Options Order",
    subHeadingDesc:
      "	Using this API, an option order can be sent to the market or destination. The options orders' parameters can be set according to the specifications mentioned in the request body.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "POST",
    endPointId: "option-orders-add-options-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/optionorders",
    requestHeaderId: "option-orders-add-options-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              text/plain
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Authorization
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"Bearer <access_token>"}
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "option-orders-add-options-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              side<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The side for the option order. Valid values:
              <ul className="bullets">
                <li>"1"</li>
                <li>"2"</li>
              </ul>
              where, 1=Buy, 2=Sell.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order. The Quantity values will be displayed up
              to 6 decimal places only. Since this is a decimal type, any
              quantity entered with non-zero fractional part will be considered
              a fractional order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which the order will be placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of order to be created. Valid values:
              <ul className="bullets">
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"4"</li>
              </ul>
              where, 1=Market, 2=Limit, 3=Stop, 4=Stop limit.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price per share. This field is valid only with Limit & Stop
              Limit order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              stopPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The Stop Price field is valid only with Stop & Stop Limit order
              types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account mnemonic as agreed between the broker and institution
              OR the account on behalf of which the order is to be placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              timeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies how long an order remains in effect. Valid values:
              <ul className="bullets">
                <li>"0"</li>
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"5"</li>
                <li>"6"</li>
              </ul>
              where, 0=Day, 1=DTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ID used to represent the transaction for compliance purposes.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Auto-generated IDs for locates acquired outside of OMS API.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              contactName
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Name of the contact from where locates have been acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRequired
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              If yes, an automated locate will be acquired from the <br />
              Server.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The rate at which the automated locate will be <br />
              acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              optionSymbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for the underlying equity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              strikePrice<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price at which the underlying equity can be exercised.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              16
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              expiryDate<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The last day before the options contract expires.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              17
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              maturityDate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It indicates the date of maturity of an Options contract.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              putOrCall<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Each enum value is defined as:
              <ul className="bullets">
                <li>"PUT"</li>
                <li>"CALL"</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              19
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              customerOrFirm<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Each enum value is defined as:
              <ul className="bullets">
                <li>"CUSTOMER"</li>
                <li>"FIRM"</li>
                <li>"CUST_BD"</li>
                <li>"CUST_MM"</li>
                <li>"NON_MEMBER_MM"</li>
                <li>"FIRM_BD"</li>
                <li>"PROPRIETARY_CUSTOMER"</li>
                <li>"PROFESSIONAL_CUSTOMER"</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              20
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              coveredOrUnCovered<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Each enum value is defined as:
              <ul className="bullets">
                <li>"COVERED"</li>
                <li>"UN_COVERED"</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cmta<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              CMTA number for the OCC.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execBroker
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The executing broker for the options trade.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              23
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              openClose<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This defines each enum value:
              <ul className="bullets">
                <li>"OPEN"</li>
                <li>"CLOSE"</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              24
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              optAttribute
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Char"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Can be used for SecurityType (167)=OPT to identify a particular
              security.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              25
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              destination
            </MDTypography>
          ),
          required: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Optional
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The execution venue where the orders will be routed to. When this
              field is not provided, the system will consider the default
              configured Destination.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "option-orders-add-options-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows an “Order Successfully Created” message with a successful HTTP status code.",
    respBodyAcceptedCodeId: "option-orders-add-options-accepted",
    respBodyAcceptedCode: "Status Code: 202 (Accepted)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              replyType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies the type of replies. Each value is as follows:
              <ul className="bullets">
                <li>SERVER_REPLY_NONE,</li>
                <li>SERVER_REPLY_WARNING, // OK|Cancel</li>
                <li>SERVER_REPLY_QUESTION, // Yes|No</li>
                <li>SERVER_REPLY_ERROR, // OK</li>
                <li>SERVER_REPLY_SUCCESS</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              operation
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies the type of operations. Each value is as follows:
              <ul className="bullets">
                <li>OPERATION_NONE = 0,</li>
                <li>OPERATION_ETB_VALIDATION,</li>
                <li>OPERATION_RESTRICTED_SYMBOL_VALIDATION,</li>
                <li>OPERATION_LIMIT_VALIDATION,</li>
                <li>OPERATION_LOCATE_QUOTE,</li>
                <li>OPERATION_LOCATE_QUOTE,</li>
                <li>OPERATION_LOCATE</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              message
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This field shows the message relevant to the response.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              extraParamsAvailable
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This field shows if any extra parameters are available or not.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              extraParams
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Extra parameters are specific to that error message.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "option-orders-add-options-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "	A bad request shows an error message with a bad request HTTP status code. If the field’s value is invalid, it shows validation error messages.",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows the errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "option_order_post" //Commenting this b/c we don't have proper response in JSON format
  },
  // Option Orders Update Option order Data
  {
    mainGridId: "update-option-order",
    subHeading: "Update Options Order",
    subHeadingDesc:
      "The Update Options Order API allows users to modify previously placed options orders.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "PUT",
    endPointId: "option-orders-update-options-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/optionorders",
    requestHeaderId: "option-orders-update-options-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              application/json
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Authorization
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"Bearer <access_token>"}
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "option-orders-update-options-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It represents the total quantity of a financial instrument in the
              order.The field values will be displayed up to 6 decimal places
              only.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Valid only with Limit & Stop Limit order types. It denotes the
              price per unit of the financial instrument in the order,
              specifying the desired execution price, with interpretation
              influenced by the ordType (Order Type) field.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The ID of the order which is to be replaced, serving as a
              distinctive identifier for reference, tracking,
              order-modification, and cancellation. (obsolete, use order ID
              instead)
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It uniquely identifies an order, serving as a distinctive
              identifier for reference, tracking, order-modification, and
              cancellation.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of order to be updated. Valid values:
              <ul className="bullets">
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"4"</li>
              </ul>
              where, 1=Market, 2=Limit, 3=Stop, 4=Stop limit.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ID used to represent the transaction for compliance purposes.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "option-update-add-options-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows an “Order successfully updated” message with the respective HTTP status code.",
    respBodyErrorId: "option-update-add-options-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code. If the field’s value is invalid, it shows validation error messages.",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows the errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of <br />
              errors if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "option_order_update" //Commenting this b/c we don't have proper response in JSON format
  },
  // Update Option Order
  {
    mainGridId: "cancel-option-order",
    subHeading: "Cancel Option Order",
    subHeadingDesc: "The Cancel Order API cancels previously placed orders.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "DELETE",
    endPointId: "option-orders-cancel-options-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/optionorders/{qOrderID}",
    requestParamsId: "option-orders-cancel-options-params",
    requestParams: "Request Params",
    requestParamsTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        {
          Header: "Param Name",
          accessor: "paramname",
          align: "left",
          width: "15%",
        },
        { Header: "", accessor: "datatype", align: "center", width: "10%" },
        { Header: "Description", accessor: "description", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          paramname: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This is the ID for the order which needs to be cancelled.
            </MDTypography>
          ),
        },
      ],
    },
    requestHeaderId: "option-orders-cancel-options-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "option-cancel-add-options-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows the message, “Success!” with the respective HTTP status code.",
    respBodyErrorId: "option-cancel-add-options-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    // respBodyErrorDesc: "A bad request shows an error message with a bad request HTTP status code. If the field’s value is invalid then it shows validation error messages.",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows the errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of <br />
              errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "option_order_cancel" //Commenting this b/c we don't have proper response in JSON format
  },
  // Cancel Option Order
  {
    mainGridId: "account-balances",
    mainHeading: "Account Balances",
    mainHeadingDesc:
      "The Account Balance API shows the balance against each user.",
  },
  {
    mainGridId: "account-balances-subscribe",
    subHeading: "Subscribe",
    subHeadingDesc:
      "The Subscribe endpoint will send users the account balance updates from the Socket. The successful return of this API endpoint will give users the current account balance.",
    subHeadingDesc2: (
      <>
        Users must connect to the SignalR Hub or Web Socket Server for the
        subscription. The details on how to connect to the hub are available
        under{" "}
        <a href="#web-socket-hub-with-signalr-endpoint">
          Web Socket Hub with SignalR
        </a>{" "}
        or <a href="#web-socket-hub-endpoint">Web Socket Hub</a>. There is a
        sample code along with the description, which users can refer to when
        subscribing to any of the methods.
      </>
    ),
    subHeadingImg: true,
    subHeadingImgDesc: (
      <>
        The updates will be sent to the Socket through the
        <span className="staus-code"> "NetLimitSummary"</span> method.
      </>
    ),
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "account-balance-subscribe-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/account/balances/subscribe",
    requestHeaderId: "account-balance-subscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "account-balance-subscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              currency
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The currency in which the account balance is shown.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              id
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Unique ID of the account balance.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              clientID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Friendly name of the account.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cash
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total cash.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              margin
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Available margin over the cash.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              firmcode
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Firm ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              CustomerCode
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Designated customer account.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              netLimit
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total balance limit.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              netUsedLimit
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total used from the balance.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "account-balance-subscribe-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
  },
  // Account Balances Subscribe Data
  {
    mainGridId: "account-balances-unsubscribe",
    subHeading: "Unsubscribe",
    subHeadingDesc:
      "The Unsubscribe endpoint will stop sending account balance updates to the Socket. Users will stop receiving updates on the account balance.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/account/balances/unsubscribe",
    endPointId: "account-balance-unsubscribe-endpoint",
    requestHeaderId: "account-balance-unsubscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "account-balance-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows the message, “Success!” with the respective HTTP status code.",
  },
  // Account Balances Unsubscribe Data
  {
    mainGridId: "locates",
    mainHeading: "Locates",
  },
  {
    mainGridId: "locate-request",
    subHeading: "Locate Request",
    endPointHeading: "Request Endpoint",
    endPointMethod: "POST",
    endPointDesc: "<base_url>/ext/ord/api/locates",
    endPointId: "locate-request-endpoint",
    requestHeaderId: "locate-request-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              text/plain
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Authorization
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"Bearer <access_token>"}
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "locate-request-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which users want to request the locate.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order for which users would like to request the
              locate.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price for which the locate is requested.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account for which the locate is requested.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "locate-request-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows the message, “Success!” with the respective HTTP status code. ",
    respBodyErrorId: "locate-request-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "locate_request" //Commenting this b/c we don't have proper response in JSON format
  },
  // Locate Request Data
  {
    mainGridId: "locate-acquire",
    subHeading: "Locate Acquire",
    endPointHeading: "Request Endpoint",
    endPointMethod: "POST",
    endPointDesc: "<base_url>/ext/ord/api/locates/acquire",
    endPointId: "locate-acquire-endpoint",
    requestHeaderId: "locate-acquire-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Text/plain
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Authorization
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"Bearer <access_token>"}
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "locate-acquire-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              quoteReqID<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Unique identifier for tracking Quote Request messages.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which users want to acquire the locate.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity for an order for which users would like to acquire
              the locate.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              timeInForce<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies how long an order remains in effect. Valid values:
              <ul className="bullets">
                <li>"0"</li>
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"5"</li>
                <li>"6"</li>
              </ul>
              where, 0=Day, 1=DTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account for which the locate is to be acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              synchronous
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Allowed values are: 0 and 1.
              <br />
              When 0: will respond back without waiting for locate-acquire
              status.
              <br />
              When 1: will respond back only when the locate-acquire status is
              received.
              <br />
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "locate-acquire-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows the message, “Success!” with the respective HTTP status code. ",
    respBodyErrorId: "locate-acquire-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "locate_acquire" //Commenting this b/c we don't have proper response in JSON format
  },
  // Locate Subscribe Data
  {
    mainGridId: "locates-subscribe",
    subHeading: "Locates Subscribe",
    subHeadingDesc:
      "The Subscribe endpoint will send users the locate updates from the Socket. The successful return of this API endpoint will give users the current state of the locates.",
    subHeadingDesc2: (
      <>
        Users must connect to the Signal R Hub or Web Socket Server for the
        subscription. The details on how to connect to the hub are available
        under
        <a href="#web-socket-hub-with-signalr">Web Socket Hub with SignalR</a>
        or <a href="#web-socket-hub">Web Socket Hub</a>. There is a sample code
        along with the description, which users can refer to when subscribing to
        any of the methods.
      </>
    ),
    subHeadingImg: true,
    subHeadingImgDesc: (
      <>
        The Socket will receive updates through the{" "}
        <span className="staus-code">"Locates"</span> method.
      </>
    ),
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/locates/subscribe",
    endPointId: "locate-subscribe-endpoint",
    requestHeaderId: "locate-subscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "locate-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects. It indicates the type of order, such as
              Market, Limit, Stop, or others, specifying the instruction for
              executing the order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of order created, including Limit, Market, etc.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              quoteReqID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              A unique identifier assigned to a Quote request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordStatus
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies Locate status:
              <ul className="bullets">
                <li>'available',</li>

                <li>'rejected,'</li>

                <li>'filled,' or</li>

                <li>'partially filled'.</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The locate quantity to be brought or sold in the order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              offerPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price offered by the Locate Provider.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              offerSize
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The offer size proposed by the Locate Provider.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cumQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The last quantity of locates acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              avgPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total average price of the locates being filled.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              statusDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The status description for the locates acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordRejReason
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Reason of order rejection.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactionStatus
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Status of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              timeInForce
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies how long an order remains in effect.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              text
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              More details for the locate requested.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              id
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The unique ID of the locate request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which an order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.16
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.17
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactTime
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The time of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.18
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              clientID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Friendly name of the account.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.19
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The "Time In Force" for the locate acquisition.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.20
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              boothID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Firm ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.21
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.22
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              etbQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The total quantity of locates available for consumption.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.23
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account ID on behalf of which the order is placed.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "locate-subscribe-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
  },
  // Locates UnSubscribe Data
  {
    mainGridId: "locates-unsubscribe",
    subHeading: "Locates Unsubscribe",
    subHeadingDesc:
      "	The Unsubscribe endpoint will stop sending locate updates to the Socket. Users will stop receiving updates of locates.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "locate-unsubscribe-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/locates/unsubscribe",
    requestHeaderId: "locate-unsubscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "locate-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "	A successful request shows the message, “Success!” with the respective HTTP status code.",
  },
  // Locates Unsubscribe Data
  {
    mainGridId: "locates-summary-subscribe",
    subHeading: "Locates Summary Subscribe",
    subHeadingDesc:
      "	The Subscribe endpoint will send users the locate summary updates from Socket. The successful return of this API endpoint will give users the current state of the locates summary.",
    subHeadingDesc2: (
      <>
        Users must connect to the SignalR Hub or Web Socket Server for the
        subscription. The details on how to connect to the hub are available
        under
        <a href="#web-socket-hub-with-signalr-endpoint">
          Web Socket Hub with SignalR
        </a>
        or <a href="#web-socket-hub-endpoint">Web Socket Hub</a>. There is a
        sample code along with the description, which users can refer to when
        subscribing to any of the methods.
      </>
    ),
    subHeadingImg: true,
    subHeadingImgDesc: (
      <>
        The Socket will receive updates through the
        <span className="staus-code">"LocateSummary"</span> method.
      </>
    ),
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "locate-summary-subscribe-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/locates/summary/subscribe",
    requestHeaderId: "locate-subscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "locate-subscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              id
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The unique ID of the locate request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which an order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactTime
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The time of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              clientID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Friendly name of the account.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The "Time In Force" for the locate acquisition.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              boothID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Firm ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              etbQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The total quantity of locates available for consumption.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account ID on behalf of which the order is placed.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "locate-unsubscribe-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
  },
  // Locates Summary UnSubscribe Data
  {
    mainGridId: "locates-summary-unsubscribe",
    subHeading: "Locates Summary Unsubscribe",
    subHeadingDesc:
      "The Unsubscribe endpoint will stop sending locate summary updates to the Socket. Users will stop receiving updates of locate summary.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "locate-summary-unsubscribe-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/locates/summary/unsubscribe",
    requestHeaderId: "locate-summary-unsubscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "locate-summary-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "	A successful request shows the message, “Success!” with the respective HTTP status code.",
  },
  // Locates Summary Unsubscribe Data
  {
    mainGridId: "orders-subscriptions",
    subHeading: "Orders Subscriptions",
    subHeadingDesc:
      "Users can subscribe and unsubscribe to multiple types of orders, as listed below under separate APIs.",
    subHeadingDesc2: (
      <>
        Users must connect to the SignalR Hub or Web Socket Server for the
        subscription. The details on how to connect to the hub are available
        under{" "}
        <a href="#web-socket-hub-with-signalr-endpoint">
          Web Socket Hub with SignalR{" "}
        </a>
        or <a href="#web-socket-hub-endpoint">Web Socket Hub</a>. There is a
        sample code along with the description, which users can refer to when
        subscribing to any of the methods.
      </>
    ),
    subHeadingImg: true,
    subHeadingImgDesc: (
      <>
        The updates will be sent to the Socket through the{" "}
        <span className="staus-code">"Orders"</span> method.
      </>
    ),
  },
  // Orders Subscriptions Data
  {
    mainGridId: "order-subscribe",
    subHeading: "Orders Subscribe",
    subHeadingDesc:
      "The Orders Subscribe endpoint will send users the orders updates from the Socket. The successful return of this API endpoint will give users the current state of Orders.",
    subHeadingDesc2:
      'The updates will be sent to the Socket through the "Orders" method.',
  },
  {
    mainGridId: "order-subscribe",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "orders-subscribes-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/subscription/orders/subscribe",
    requestHeaderId: "orders-subscribes-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "orders-subscribes-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The ID for the created order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price on which the order was created. The field is valid for
              Limit orders only, 0 for other order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which an order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              sideDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The side for the order, including Buy or Sell.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies order status:
              <ul className="bullets">
                <li>'filled,'</li>

                <li>'partially filled' or</li>

                <li>'rejected', etc.</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              text
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Free format text string that specifies order details such as
              reasons for order rejection.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              side
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The side for the order, including Buy or Sell.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of order to be updated. Valid values:
              <ul className="bullets">
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"4"</li>
              </ul>
              where, 1=Market, 2=Limit, 3=Stop, 4=Stop limit.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              stopPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The Stop Price field only valid for Stop & Stop Limit order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              timeInForce
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies how long an order remains in effect. Valid values:
              <ul className="bullets">
                <li>"0"</li>
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"5"</li>
                <li>"6"</li>
              </ul>
              where, 0=Day, 1=DTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactTime
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The time of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              clOrdID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              FIX client order ID assigned by institution.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              tifDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of time in force.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.16
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderTypeDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of order type.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.17
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              statusDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The status description for the created order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.18
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              avgPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Average price of the order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.19
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cumQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total filled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.20
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              workableQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total workable quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.21
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              leavesQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Unfilled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.22
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.23
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolWithoutSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.24
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ID used to represent this transaction for compliance purposes.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.25
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Auto-generated IDs for the locates acquired outside of OMS API.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.26
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              contactName
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Name of the contact from where the locates have been acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.27
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRequired
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              If true, an automated locate will be acquired from the Server.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.28
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The rate at which the automated locate will be acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.29
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              destination
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Destination using which the order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.30
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account for which the order was created.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "orders-subscribes-no-content",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Orders Unsubscribe
  {
    mainGridId: "orders-unsubscribe",
    subHeading: "Orders Unsubscribe",
    subHeadingDesc:
      "The Unsubscribe endpoint will stop sending orders' updates to the Socket. Users will stop receiving updates on orders.",
    endPointId: "orders-unsubscribes-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/subscription/orders/unsubscribe",
    requestHeaderId: "orders-unsubscribes-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "orders-unsubscribes-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows the message, “Success!” with the respective HTTP status code. ",
    respBodyErrorId: "orders-unsubscribes-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Orders Unsubscribe Data
  {
    mainGridId: "option-orders-subscribe",
    subHeading: "Options Orders Subscribe",
    subHeadingDesc:
      "The Subscribe endpoint will send users the options orders' updates from the Socket. The successful return of this API endpoint will give users the current state of options orders. ",
    subHeadingDesc2: (
      <>
        The Socket will receive updates through the
        <span className="staus-code">"OptionOrders”</span> method.
      </>
    ),
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/subscription/optionorders/subscribe",
    endPointId: "orders-unsubscribes-endpoint",
    requestHeaderId: "option-orders-subscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "option-orders-subscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              QuickFIX identifier for an options order. It uniquely identifies
              the order within the system.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This stringified order ID uniquely identifies the order within the
              system.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price on which the order was created. Valid for Limit orders
              only, 0 for other order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              sideDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The side for the order, including Buy or Sell.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies Order status:
              <ul className="bullets">
                <li>'filled,'</li>

                <li>'partially filled' or</li>

                <li>'rejected', etc.</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              text
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Free format text string that specifies order details such as
              reasons for order rejection.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              side
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The side for the order, including Buy or Sell.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity for an order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This includes the side of the order. Valid values:
              <ul className="bullets">
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"4"</li>
              </ul>
              where, 1=Market, 2=Limit, 3=Stop, 4=Stop limit.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              stopPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The Stop Price field only valid with Stop & Stop Limit order
              types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              timeInForce
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies how long an order remains in effect. Valid values:
              <ul className="bullets">
                <li>"0"</li>
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"5"</li>
                <li>"6"</li>
              </ul>
              where, 0=Day, 1=DTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactTime
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The time of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              clOrdID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              FIX client order ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.16
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              tifDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of time in force.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.17
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderTypeDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of order type.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.18
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              statusDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The status description for the created order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.19
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              avgPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Average price of the order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.20
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cumQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total filled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.21
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              workableQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total workable quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.22
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              leavesQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Unfilled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.23
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.24
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolWithoutSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.25
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The system-generated order ID from which the order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.26
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Auto-generated IDs for the locates acquired outside of OMS API.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.27
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              contactName
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Name of the contact from where locates have been acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.28
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRequired
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              If yes, an automated locate will be acquired from the Server.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.29
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The rate at which the automated locate will be acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.30
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              optionSymbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for the underlying Equity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.31
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              strikePrice
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price at which the underlying equity can be exercised.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.32
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              maturityDay
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Int"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The last day on which the options can be exercised into the
              underlying equity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.33
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              maturityMonthYear
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Month and Year for the Maturity Day.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.34
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              putOrCall
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Each enum value is defined as:
              <ul className="bullets">
                <li>“PUT”</li>

                <li>“CALL”</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.35
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              customerOrFirm
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Each enum value is defined as:
              <ul className="bullets">
                <li>“CUSTOMER”,</li>
                <li>“FIRM”,</li>
                <li>“CUST_BD”,</li>
                <li>“CUST_MM”,</li>
                <li>“NON_MEMBER_MM”,</li>
                <li>“FIRM_BD”,</li>
                <li>“PROPRIETARY_CUSTOMER”,</li>
                <li>“PROFESSIONAL_CUSTOMER”</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.36
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              coveredOrUncovered
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Each enum value is defined as:
              <ul className="bullets">
                <li>“COVERED”</li>

                <li>“UN_COVERED”</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.37
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cmta
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              CMTA number for the OCC.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.38
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execBroker
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Exec broker is the executing broker.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.39
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              openClose
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This defines each enum value:
              <br />
              “OPEN=O”, “CLOSE=C”
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.40
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              destination
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Destination using which the Order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.41
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account for which the order was created.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "option-orders-subscribe-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Option Orders Subscribe Data
  {
    mainGridId: "option-orders-unsubscribe",
    subHeading: "Options Orders Unsubscribe",
    subHeadingDesc:
      "The Unsubscribe endpoint will stop sending options orders' updates to the Socket. Users will stop receiving updates on the options orders.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "option-orders-subscribe-endpoint",
    endPointDesc:
      "<base_url>/ext/ord/api/subscription/optionorders/unsubscribe",
    requestHeaderId: "option-orders-unsubscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "option-orders-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows the message, “Success!” with the respective HTTP status code.",
    respBodyErrorId: "option-orders-unsubscribe-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Option Orders Unsubscribe Data
  {
    mainGridId: "open-orders-subscribe",
    subHeading: "Open Orders Subscribe",
    subHeadingDesc:
      "The Subscribe endpoint will send users the open orders' updates from Socket. The successful return of this API endpoint will give users the current state of open orders. ",
    subHeadingDesc2: (
      <>
        The Socket will receive updates through the
        <span className="staus-code">
          <i>"OpenOrders"</i>
        </span>
        method.
      </>
    ),
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "option-orders-unsubscribe-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/subscription/openorders/subscribe",
    requestHeaderId: "open-orders-subscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "open-orders-subscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Array
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The ID for the created order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This stringified order ID uniquely identifies the order within the
              system.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price on which the order was created. Valid for Limit order, 0
              for other order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The Symbol for which an order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              sideDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The side for the order, including Buy or Sell.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies Order status:
              <ul className="bullets">
                <li>'filled,'</li>

                <li>'partially filled' or</li>

                <li>'rejected', etcetera.</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              text
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Free format text string that specifies order details such as
              reasons for order rejection.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              side
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The side for the order, including Buy or Sell.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of order to be updated. Valid values:
              <ul className="bullets">
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"4"</li>
              </ul>
              where, 1=Market, 2=Limit, 3=Stop, 4=Stop limit.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              stopPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The Stop Price field only valid with Stop & Stop Limit order
              types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              timeInForce
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies how long an order remains in effect. Valid values:
              <ul className="bullets">
                <li>"0"</li>
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"5"</li>
                <li>"6"</li>
              </ul>
              where, 0=Day, 1=DTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactTime
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The time of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              clOrdID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              FIX client order ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.16
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              tifDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of time in force.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.17
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderTypeDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of order type.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.18
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              statusDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The status description for the created order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.19
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              avgPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Average price of the order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.20
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cumQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total filled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.21
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              workableQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total workable quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.22
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              leavesQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Unfilled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.23
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.24
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolWithoutSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.25
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ID used to represent this transaction for compliance purposes.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.26
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Auto-generated IDs for locates acquired outside of OMS API.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.27
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              contactName
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Name of the contact from where the locates have been acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.28
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRequired
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              If yes, an automated locate will be acquired from the Server.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.29
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The rate at which the automated locate will be acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.30
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              destination
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Destination using which the order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.31
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account for which the order was created.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "open-orders-subscribe-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code. ",
  },
  // Open Orders Unsubscribe
  {
    mainGridId: "open-orders-unsubscribe",
    subHeading: "Open Orders Unsubscribe",
    subHeadingDesc:
      "The Unsubscribe endpoint will stop sending open orders' updates to the Socket. Users will stop receiving updates on the open orders.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "open-orders-unsubscribe-endpoint",
    endPointDesc:
      "<base_url>/ext/ord/api/subscription/optionorders/unsubscribe",
    requestHeaderId: "open-orders-unsubscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "open-orders-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows the message, “Success!” with the respective HTTP status code.",
    respBodyErrorId: "open-orders-unsubscribe-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Option Orders Unsubscribe Data
  {
    mainGridId: "executions-subscribe",
    subHeading: "Executions Subscribe",
    subHeadingDesc:
      "The subscribe endpoint will send you the executions updates from the Web Socket. The successful return of this API endpoint will give you the current executions.",
    subHeadingDesc2: (
      <>
        The Socket will receive updates through the
        <span className="staus-code">"Executions"</span> method.
      </>
    ),
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "executions-subscribe-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/subscription/executions/subscribe",
    requestHeaderId: "executions-subscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "executions-subscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The ID for the created order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This stringified order ID uniquely identifies the order within the
              system.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price at which the order is created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              side
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The side for the order, including Buy or Sell.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies Order status:
              <ul className="bullets">
                <li>'filled,'</li>

                <li>'partially filled' or</li>

                <li>'rejected'</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              text
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              More details for the locate requested.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactTime
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The time of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordStatus
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies Locate status:
              <ul className="bullets">
                <li>'available',</li>

                <li>'rejected,' </li>

                <li>'filled,' or</li>

                <li>'partially filled', etc.</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execBroker
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The executing broker.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              timeInForce
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies how long an order remains in effect. Valid values:
              <ul className="bullets">
                <li>"0"</li>
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"5"</li>
                <li>"6"</li>
              </ul>
              where, 0=Day, 1=DTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of order to be updated. Valid values:
              <ul className="bullets">
                <li>"1"</li>
                <li>"2"</li>
                <li>"3"</li>
                <li>"4"</li>
              </ul>
              where, 1=Market, 2=Limit, 3=Stop, 4=Stop limit.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity for an order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              origClOrdID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              FIX client order ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.16
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execRefID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Execution reference ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.17
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              lastPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Last price is execution price.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.18
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Execution ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.19
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies the execution type.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.20
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execTransType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies the execution transaction type.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.21
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execTransTypeDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of the execution transaction type.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.22
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              leavesQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Unfilled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.23
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              lastShares
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of the executed order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.24
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cumQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total filled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.25
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              avgPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Average price of the order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.26
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              tradeDate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The date of trade.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.27
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.28
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              sideDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Description for the Side of an order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.29
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              destination
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Destination using which the Order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.30
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account for which the order was created.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "executions-subscribe-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Executions Unsubscribe
  {
    mainGridId: "executions-unsubscribe",
    subHeading: "Executions Unsubscribe",
    subHeadingDesc:
      "The Unsubscribe endpoint will stop sending execution updates to Socket. Users will stop receiving updates on the execution of orders.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "executions-unsubscribe-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/subscription/executions/unsubscribe",
    requestHeaderId: "executions-unsubscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "executions-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows the message, “Success!” with the respective HTTP status code. ",
    respBodyErrorId: "executions-unsubscribe-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Positions Subscribe
  {
    mainGridId: "positions-subscribe",
    subHeading: "Positions Subscribe",
    subHeadingDesc:
      "The Subscribe endpoint will send users the positions' updates from the Socket. The successful return of this API endpoint will give users the current state of the positions. ",
    subHeadingDesc2: (
      <>
        The Socket will receive updates through the
        <span className="staus-code">"Positions"</span> method.
      </>
    ),
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/subscription/positions/subscribe",
    endPointId: "positions-subscribe-endpoint",
    requestHeaderId: "positions-subscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "positions-subscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which the position exists.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              positionString
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The current position. Valid values:
              <ul className="bullets">
                <li>Flat</li>
                <li>Long</li>
                <li>Short</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              avgPrice
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The average price of the position.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              totDollarOfTrade
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Cost of the users current position.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              realizedPnL
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The profit and loss which has been realized.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Current position of a stock.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account for which the order was created.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
  },
  // Positions Subscribe Data
  {
    mainGridId: "positions-unsubscribe",
    subHeading: "Positions Unsubscribe",
    subHeadingDesc:
      "The Unsubscribe endpoint will stop sending positions' updates to Socket. Users will stop receiving updates on the positions.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "positions-unsubscribe-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/subscription/positions/unsubscribe",
    requestHeaderId: "positions-unsubscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "positions-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "	A successful request shows the message, “Success!” with the respective HTTP status code.",
    respBodyErrorId: "positions-unsubscribe-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Web Socket Hub
  {
    SampleCode: true,
    index: 0,
    mainHeading: "Web Socket Hub",
    mainGridId: "web-socket-hub",
    mainHeadingDesc:
      "Users can connect to Web Socket Hub to receive real-time transaction notifications.",
    endPointHeading: "Handshake Endpoint",
    endPointMethod: "URL",
    endPointId: "web-socket-hub-endpoint",
    endPointDesc:
      "wss://<base_url>/transactionalws?access_token=<access_token>",
    requestHeaderId: "wse-request-query-params",
    requestHeader: "Request Query Params",
    requestHeaderTableData: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        {
          Header: "Query Param Name",
          accessor: "qpns",
          align: "left",
          width: "20%",
        },
        { Header: "", accessor: "datatype", align: "left", width: "10%" },
        { Header: "Description", accessor: "desc", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          qpns: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              access_token
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          desc: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The access token which users receive from the{" "}
              <a href="#authorizations">login API</a>.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "wse-message-format",
    respBody: "Message Format",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              method
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The method name identifies the type of subscription like
              <br /> "NetLimitSummary," "Orders," "OpenOrders," etc.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Data
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The data type for this property will be identified by the type of
              subscription.
            </MDTypography>
          ),
        },
      ],
    },
    SampleCodeTitle: "Sample Code",
    SampleCodeId: "wse-sample-code",
  },
  // Web Socket Hub with SignalR
  {
    SampleCode: true,
    index: 1,
    mainHeading: "Web Socket Hub with SignalR",
    mainGridId: "web-socket-hub-with-signalr",
    mainHeadingDesc:
      "Users can connect to the Web Socket SignalR Hub to receive real-time transaction notifications.",
    endPointHeading: "Handshake Endpoint",
    endPointMethod: "URL",
    endPointId: "web-socket-hub-with-signalr-endpoint",
    endPointDesc: "<base_url>/transactional",
    requestHeaderId: "ws-http-connection-options",
    requestHeader: "HTTP Connection Options",
    requestHeaderTableData: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              accessTokenFactory
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Method"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The access token which users receive from the{" "}
              <a href="#request-access-token-request-endpoint">Login API.</a>
            </MDTypography>
          ),
        },
      ],
    },
    SampleCodeTitle: "Sample Code",
    SampleCodeId: "ws-sample-code",
  },
  {
    staticData: true,
    mainHeading: "Sample Flow",
    mainGridId: "sample-flow",
    mainHeadingDesc:
      "This sample flow shows users how to request access tokens with Postman and use that token for creating orders, subscribing to orders, and receiving order updates from the Socket.",
    imgIndex: -1,
  },
  {
    staticData: true,
    subHeading: "Step 1:",
    subHeadingDesc:
      "Request access token with Postman by defining body x-www-form-urlencoded and in response, users receive an access token which they can use for other protected APIs in Step 2.",
    imgIndex: 0,
  },
  {
    staticData: true,
    subHeading: "Step 2:",
    subHeadingDesc:
      "Use the access token in the authorization section by selecting Authorization Type as Bearer Token.",
    imgIndex: 1,
  },
  {
    staticData: true,
    imgIndex: 2,
    subHeading: "Step 3:",
    subHeadingDesc: `After entering the access token in the Authorization Header, users can request to create an order by selecting Body as an application/JSON and writing the requested body in JSON. A notification will pop up with status code 200: "Order successfully created," will appear. In the next step, users can subscribe to the orders.`,
  },
  {
    staticData: true,
    subHeading: "Step 4:",
    subHeadingDesc:
      "Users can subscribe to view the current state of the order created in Step 3 and the rest of the updates that users can receive from the Socket as mentioned above.",
    imgIndex: 3,
  },
  {
    staticData: true,
    mainHeading: "Support",
    mainGridId: "support",
    mainHeadingDesc: "For API support, please contact",
    supportEmail: "webomsapi@vcttechnologiesllc.com",
  },
  {
    staticData: true,
    mainHeading: "Disclaimer and Confidentiality Notice",
    mainGridId: "disclaimer-and-confidentiality-notice",
    mainHeadingDesc:
      "The information contained in these documents is confidential, privileged, and only for the information of the intended, recipient and may not be used, published, or redistributed without the prior written consent of VCT Technologies LLC.",
    mainHeadingDesc2:
      "The information is provided with care in this document, VCT Technologies LLC makes no representations and gives no warranties of whatever nature in respect of these documents, including but not limited to the accuracy or completeness of any information, facts, and/or opinions contained therein. VCT Technologies LLC, its subsidiaries, the directors, employees, and agents cannot be held liable for the use and reliance of the information provided in these documents.",
  },
];

export const TableData2 = {
  websockparamcol: [
    { Header: "S/N", accessor: "num", align: "left", width: "5%" },
    {
      Header: "Query Param Name",
      accessor: "qpns",
      align: "left",
      width: "20%",
    },
    { Header: "", accessor: "datatype", align: "left", width: "10%" },
    { Header: "Description", accessor: "desc", align: "left" },
  ],

  websockparamrow: [
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          1
        </MDTypography>
      ),
      qpns: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          access_token
        </MDTypography>
      ),
      datatype: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          <MDBadge
            color="success"
            badgeContent={"String"}
            variant="gradient"
            size="sm"
          ></MDBadge>
        </MDTypography>
      ),
      desc: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          The access token which users receive from the{" "}
          <a href="#authorizations">login API</a>.
        </MDTypography>
      ),
    },
  ],

  websocksmgcol: [...bodyColumnHeaders],

  websocksmgrow: [
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          1
        </MDTypography>
      ),
      field: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          method
        </MDTypography>
      ),
      datatype: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          <MDBadge
            color="success"
            badgeContent={"String"}
            variant="gradient"
            size="sm"
          ></MDBadge>
        </MDTypography>
      ),
      description: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          The method name identifies the type of subscription like
          <br /> "NetLimitSummary," "Orders," "OpenOrders," etc.
        </MDTypography>
      ),
    },
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          2
        </MDTypography>
      ),
      field: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          data
        </MDTypography>
      ),
      datatype: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          <MDBadge
            color="success"
            badgeContent={"Object"}
            variant="gradient"
            size="sm"
          ></MDBadge>
        </MDTypography>
      ),
      description: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          The data type for this property will be identified by the type of
          subscription.
        </MDTypography>
      ),
    },
  ],

  websockircol: [...bodyColumnHeaders],

  websockirrow: [
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          1
        </MDTypography>
      ),
      field: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          accessTokenFactory
        </MDTypography>
      ),
      datatype: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          <MDBadge
            color="success"
            badgeContent={"Method"}
            variant="gradient"
            size="sm"
          ></MDBadge>
        </MDTypography>
      ),
      description: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          The access token which users receive from the{" "}
          <a href="#request-access-token-request-endpoint">login API.</a>
        </MDTypography>
      ),
    },
  ],
};

export default tradingApiData;
